// Helper function to format price and area
const formatValue = (value, type = "number") => {
    if (value == null) return "k.A.";
  
    // Return raw value for 'number' type (like build year)
    if (type === "number") return value;
  
    const formatter = new Intl.NumberFormat('de-DE', {
      style: type === "currency" ? "currency" : undefined,
      currency: "EUR",
      maximumFractionDigits: type === "area" ? 2 : 0,
    });
  
    return type === "area" ? `${formatter.format(value)} m²` : formatter.format(value);
  };

  export { formatValue };